<div class = "row my-row pt-5 pb-5">
    <!-- Titre de la page -->
    <div class="col-xl-12 my-col">
      <h1>{{ "SETTINGS.USER.TITLE" | translate}}</h1>
    </div>
    <div class='container-fluid my-container'>
        <div class='row my-row'>
            <div class='col-11 pb-5 my-col'>
                <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SETTINGS.USER.MAIL-MODAL-TITLE" | translate}}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <div class='row row-cols-1 my-row'>
                                <div class='col my-col'>
                                    <p>{{ "SETTINGS.USER.MAIL" | translate}} : <span class='font-weight-bold'>
                                        {{userService.currentUser.keycloakUser.tokenParsed.email}}</span>
                                    </p>
                                </div>
                            </div>
                      </div>
                    </div>
                </div>
            </div>

            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SETTINGS.USER.PASSWORD-MODAL-TITLE" | translate}}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <div class='row my-row'>
                                <div class='col my-col'>
                                    <button type="button" class="btn btn-success" (click)="askChangePassword()">
                                        {{ "SETTINGS.USER.PASSWORD-BUTTON-TEXT" | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="this.responsable">
                <div class='col-11 pb-5 my-col'>
                    <div class='card'>
                        <div class='card-header'>
                            {{ "SETTINGS.USER.RESPONSABLE" | translate}}
                        </div>
                        <div class='card-body'>
                            <div class='container-fluid my-container'>
                                <div class='row my-row'>
                                    <div class='col my-col'>
                                        {{ "SETTINGS.USER.RESPONSABLE-TEXT" | translate }} {{this.responsable.res_description}} ( {{this.responsable.res_email}} {{ this.responsable.res_identifiant}} )
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SETTINGS.USER.INFORMATIONS-MODAL-TITLE" | translate}}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <div class='row row-cols-1 my-row'>
                                <form *ngIf="userForm" [formGroup]="userForm" autocomplete="off"
                                novalidate (ngSubmit)="updateUserInformations(userForm.value)">
                                    <div class="col my-col" *ngIf="civiliteTab.length > 0">
                                        <label>{{ "FORM.CIVILITE-LABEL" | translate}} :</label>
                                        <mat-form-field class="ml-2">
                                            <mat-label>{{ "FORM.CIVILITE-SELECT" | translate }}</mat-label>
                                            <mat-select placeholder="{{ 'FORM.CIVILITE-SELECT' | translate }}"
                                            formControlName="civilite">
                                                <mat-option value=""></mat-option>
                                                <mat-option *ngFor="let civ of civiliteTab" [value]="civ.id">
                                                    {{ civ.libelle }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class='col my-col mt-1'>
                                        <label for="lname">{{ "FORM.LNAME" | translate}} :</label>
                                        <input type="text" class="form-control"
                                        placeholder="{{ 'FORM.LNAME' | translate}}" formControlName="lname" id="lname">
                                     </div>
                                     <div class='col my-col mt-1'>
                                        <label for="fname">{{ "FORM.FNAME" | translate}} :</label>
                                        <input type="text" class="form-control"
                                        placeholder="{{ 'FORM.FNAME' | translate}}" formControlName="fname" id="fname">
                                     </div>
                                     <div class='col my-col mt-1'>
                                        <label for="phoneNumber">{{ "FORM.PHONE" | translate}} :</label>
                                        <input type="text" class="form-control"
                                        placeholder="{{ 'FORM.PHONE' | translate}}"
                                        formControlName="phoneNumber" id="phoneNumber">
                                        <mat-error *ngIf="hasError('phoneNumber','forbidden')">
                                            {{ "ERRORS.PHONE-INVALID" | translate }}
                                        </mat-error>
                                        <mat-error *ngIf="hasError('phoneNumber','required')">
                                            {{ "ERRORS.PHONE-REQUIRED" | translate }}
                                        </mat-error>
                                     </div>
                                     <div class='col my-col mt-2'>
                                        <button type="submit" class="btn btn-success" [disabled]="!userForm.valid">
                                            {{ "BUTTONS.UPDATE" | translate}}
                                        </button>
                                     </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
